/* eslint-disable no-console */
import env from './env';

const logger = {
    /**
     * 输出info级别日志
     * @param msg
     */
    info(msg) {
        // 只在开发环境输出日志
        if (env.VUE_APP_LOCAL) {
            console.log(msg);
        }
    },
    /**
     * 输出warn级别日志
     * @param msg
     */
    warn(msg) {
        // 只在开发环境输出日志
        if (env.VUE_APP_LOCAL) {
            console.warn(msg);
        }
    },
    /**
     * 输出error级别日志
     * @param msg
     */
    error(msg) {
        // 只在开发环境输出日志
        if (env.VUE_APP_LOCAL) {
            console.error(msg);
        }
    }
};

export default logger;
